<template>
  <main-layout class="storage-process" page-title="加工数据填报">
    <div slot="main-content" class="main-content">
      <div class="storageProcessFrom">
        <!-- 第三步   -->
        <el-form
          v-if="showThree"
          ref="FormThree"
          class="form-box"
          size="medium"
          :model="InfoFormThree"
          :rules="rulesThree"
        >
          <div class="form-row">
            <el-form-item label="成品名称：" prop="productName">
              <el-select
                :disabled="disabledThree"
                value-key="productCode"
                class="companyTypeSelect"
                v-model="InfoFormThree.productInfo"
                placeholder="请选择成品名称"
                @change="changeProduct"
              >
                <el-option
                  v-for="item in productList"
                  :key="item.productCode"
                  :label="item.productName"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="加工企业：" prop="outside">
              <el-radio-group
                :disabled="disabledThree"
                v-removeAriaHidden
                v-model="InfoFormThree.outside"
                @input="handleChangeCompany"
              >
                <el-radio :label="0">本单位</el-radio>
                <el-radio :label="1">外单位</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="加工企业名称：" prop="processCompanyName">
              <el-input
                class="ipt"
                v-model="InfoFormThree.processCompanyName"
                placeholder="请输入加工企业名称"
                :disabled="disFlag"
              ></el-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码：" prop="processCompanyCode">
              <el-input
                class="ipt"
                v-model="InfoFormThree.processCompanyCode"
                :disabled="disFlag"
                placeholder="请输入统一社会信用代码"
              ></el-input>
            </el-form-item>
            <el-form-item label="包装规格：" prop="productSpec">
              <el-input
                class="ipt"
                :disabled="disabledThree"
                v-model="InfoFormThree.productSpec"
                placeholder="请输入包装规格"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="生产日期：" prop="productDate">
              <el-date-picker
                :disabled="disabledThree"
                v-model="InfoFormThree.productDate"
                type="date"
                :picker-options="pickerDateOptions"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                @change="handleChange"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="产品批次号：" prop="riceBatchCode">
              <el-input
                class="ipt"
                :disabled="disabledThree"
                v-model="InfoFormThree.riceBatchCode"
                placeholder="请产品批次号"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="保质期：" prop="warrantyDays">
              <el-input
                class="ipt"
                :disabled="disabledThree"
                v-model="InfoFormThree.warrantyDays"
                placeholder="请输入保质期"
              >
                <template slot="append">天</template></el-input
              >
            </el-form-item>

            <div class="addBtn">
              <el-button v-if="!showFour" type="primary" @click="addFourStep"
                >+上传检测报告</el-button
              >
              <div v-else class="title">检测报告</div>
            </div>
          </div>
        </el-form>
        <!-- 第四步 -->
        <el-form
          v-if="showFour"
          ref="FormFour"
          class="form-box"
          size="medium"
          :model="InfoFormFour"
          :rules="rulesFour"
        >
          <div class="form-row">
            <el-form-item label="校验日期：" prop="checkDate">
              <el-date-picker
                v-model="InfoFormFour.checkDate"
                type="date"
                :picker-options="pickerDateOptions"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="检测单位名称：" prop="checkCompanyName">
              <el-input
                class="ipt"
                v-model="InfoFormFour.checkCompanyName"
                placeholder="请输入检测单位名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="检测报告：" prop="imagesUrl">
              <div class="img-list">
                <div class="img-list-item" v-if="InfoFormFour.imagesUrl">
                  <!-- <el-image
                    :src="InfoFormFour.imagesUrl"
                    :preview-src-list="[InfoFormFour.imagesUrl]"
                  /> -->
                  <object
                    :data="InfoFormFour.imagesUrl"
                    width="120px"
                    height="120px"
                  ></object>
                  <i class="el-icon-error" @click="removeImg"></i>
                </div>
                <el-upload
                  v-if="!InfoFormFour.imagesUrl"
                  class="upload-img"
                  :action="uploadAction"
                  accept=".jpg,.gif,.png,.jpeg,.bmp,.pdf,.GIF,.BMP,.JPG,.JPEG,.PNG"
                  :show-file-list="false"
                  :on-change="handleFileChange"
                  :auto-upload="false"
                  :on-error="handleError"
                  v-loading="uploading"
                >
                  <div class="img-add">
                    <i class="el-icon-plus"></i>
                    上传文件
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </div>
        </el-form>
        <span class="dialog-footer">
          <el-button type="primary" @click="submitForm('FormFour', true)"
            >确 定</el-button
          >
          <el-button @click="handleCancel">取 消</el-button>
        </span>
      </div>
    </div>
  </main-layout>
</template>

<script>
import { snkd } from "@/api/api";
import MainLayout from "@/layout/MainLayout";
import { v4 as uuidv4 } from "uuid";
import { upload } from "@/api/request/snkd.foundation";
import { getStorage } from "@/utils/storage";
import {
  insertOrUpdateThreeForEgg,
  insertOrUpdateFourForEgg,
  getProductList,
} from "@/api/request/snkd.produce";
const companyInfo = getStorage("COMPANYINFO");
const farmInfo = getStorage("FARMINFO");
export default {
  name: "detailInfo",
  components: { MainLayout },
  props: {},
  data() {
    const validateInteger = (rule, value, callback) => {
      if (value && !/^[1-9]\d*$/.test(value)) {
        return callback(new Error("请输入正整数"));
      }
      return callback();
    };
    return {
      showThree: true,
      showFour: false,
      disFlag: false,
      disabledThree: false,
      disabledCode: false,
      codeTips: false,
      higherLevel: null, //上一模块提交后id
      productList: [], //成品名称下拉列表
      InfoFormThree: {
        productName: "",
        productInfo: null,
        outside: "",
        processCompanyName: "",
        processCompanyCode: "",
        productDate: "",
        warrantyDays: "",
        productSpec: "",
        riceBatchCode: "",
      },
      InfoFormFour: {
        checkDate: "",
        checkCompanyName: "",
        imagesUrl: "",
      },
      rulesThree: {
        productName: [
          { required: true, message: "请选择成品名称", trigger: "change" },
        ],
        outside: [
          { required: true, message: "请选择加工企业", trigger: "change" },
        ],
        processCompanyName: [
          { required: true, message: "请输入加工企业名称", trigger: "change" },
        ],
        productDate: [
          { required: true, message: "请选择生产日期", trigger: "change" },
        ],
        warrantyDays: [
          {
            required: true,
            trigger: "change",
            message: "请输入保质期",
          },
          {
            validator: validateInteger,
            trigger: "blur",
          },
        ],
        productSpec: [
          {
            required: true,
            trigger: "change",
            message: "请输入包装规格",
          },
        ],
        riceBatchCode: [
          { required: true, message: "请输入批次号", trigger: "change" },
        ],
      },
      rulesFour: {
        checkDate: [
          { required: true, message: "请选择校验日期", trigger: "change" },
        ],
        checkCompanyName: [
          { required: true, message: "请输入检测单位名称", trigger: "change" },
        ],
        imagesUrl: [
          { required: true, message: "请上传检测报告", trigger: "change" },
        ],
      },
      uploadAction: snkd.foundation.file.upload,
      uploading: false,
      pickerDateOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  mounted() {
    this.InfoFormThree.productDate = new Date().format("yyyy-MM-dd");
    this.InfoFormThree.riceBatchCode = new Date().format("yyyyMMdd") + "SH";
    this.InfoFormFour.checkDate = new Date().format("yyyy-MM-dd");
    this.InfoFormFour.checkCompanyName = companyInfo.companyName;
    this.getProductListHandle();
  },
  methods: {
    //获取成品下拉
    async getProductListHandle() {
      const res = await getProductList({
        cropId: this.$route.query.cropId,
        farmId: farmInfo.farmId,
      });
      if (res.respCode == 0) {
        this.productList = res.obj;
      }
    },
    //选择成品
    changeProduct(val) {
      this.InfoFormThree.productName = val.productName;
      this.InfoFormThree.productSpec = val.productSpec || "";
      this.InfoFormThree.warrantyDays = val.warrantyDays || "";
    },
    addFourStep() {
      this.submitForm("FormThree");
    },
    //加工企业选择
    handleChangeCompany() {
      if (this.InfoFormThree.outside === 0) {
        this.InfoFormThree.processCompanyName = companyInfo.companyName;
        this.InfoFormThree.processCompanyCode =
          companyInfo.enterpriseCreditCode;
        this.disFlag = true;
      } else {
        this.InfoFormThree.processCompanyName = "";
        this.InfoFormThree.processCompanyCode = "";
        this.disFlag = false;
      }
    },

    handleChange(val) {
      this.InfoFormThree.riceBatchCode = val.replace(/-/g, "") + "SH";
    },
    //移除图片
    removeImg() {
      this.InfoFormFour.imagesUrl = "";
    },
    //提交表单
    async submitForm(formName, flag) {
      if (flag) {
        if (this.showThree) {
          formName = "FormThree";
          if (this.showFour) {
            formName = "FormFour";
          }
        }
      }
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.$confirm("请确保填写信息是否准确，保存后将无法修改", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            customClass: "confirm-dialog",
            type: "warning",
          })
            .then(async () => {
              var body = {
                companyId: companyInfo.companyId,
                farmId: farmInfo.farmId,
              };
              try {
                this.loading = true;
                if (formName === "FormThree") {
                  body = {
                    ...body,
                    ...this.InfoFormThree,
                    paddyBatchCode: this.$route.query.certificateNo,
                  };
                  const res3 = await insertOrUpdateThreeForEgg(body);
                  if (!res3.respCode) {
                    this.higherLevel = res3.obj.id;
                    if (!flag) {
                      this.disabledThree = true;
                    }
                    this.$message({
                      type: "success",
                      message: `保存成功`,
                    });
                    if (!flag) {
                      this.showFour = true;
                    }
                    if (flag) {
                      this.$router.push({
                        path: "/storageProcessForEggList",
                        query: {
                          certificateNo: this.$route.query.certificateNo,
                          cropName: this.$route.query.cropName,
                          cropId: this.$route.query.cropId,
                        },
                      });
                    }
                  }
                }
                if (formName === "FormFour") {
                  body = {
                    ...body,
                    ...this.InfoFormFour,
                    outputProcessId: this.higherLevel,
                  };
                  const res4 = await insertOrUpdateFourForEgg(body);
                  if (!res4.respCode) {
                    this.$message({
                      type: "success",
                      message: `保存成功`,
                    });
                    if (flag) {
                      this.$router.push({
                        path: "/storageProcessForEggList",
                        query: {
                          certificateNo: this.$route.query.certificateNo,
                          cropName: this.$route.query.cropName,
                          cropId: this.$route.query.cropId,
                        },
                      });
                    }
                  }
                }
              } catch (error) {
                console.log(error);
              } finally {
                this.loading = false;
              }
            })
            .catch(() => {
              console.log("已取消");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //取消表单
    handleCancel() {
      this.showFour = false;
      this.$refs["FormThree"]?.resetFields();
      this.$refs["FormFour"]?.resetFields();
      this.$router.push({
        path: "/storageProcessForEggList",
        query: {
          certificateNo: this.$route.query.certificateNo,
          cropName: this.$route.query.cropName,
          cropId: this.$route.query.cropId,
        },
      });
    },

    async handleFileChange(file) {
      this.uploading = true;
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("图片上传大小不超过10MB");
        return false;
      }
      await this.submitFileForm(file);
    },
    handleError(err) {
      console.log("handleError", err);
      this.uploading = false;
    },
    // 提交上传文件
    async submitFileForm(file) {
      let formData = new FormData();
      const dir = "snkoudai/web/";
      const fileType = file.raw["type"];
      const index = fileType.lastIndexOf("/") + 1;
      const fileFormat = fileType.substring(index, fileType.length);
      var fileName = `${uuidv4()}.${fileFormat}`;
      formData.append("file", file.raw);
      formData.append("folderPath", dir);
      formData.append("originalFilename", fileName);
      this.uploading = true;
      await upload(formData)
        .then((res) => {
          const uploadRet = res && res.obj && res.obj.internetUrl;
          if (!uploadRet) return;
          this.InfoFormFour.imagesUrl = res.obj.internetUrl;
          this.uploading = false;
        })
        .catch(() => {
          this.$message.error("上传失败！");
          this.uploading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.storage-process {
  .main-content {
    width: 1200px;
    min-height: calc(100vh - 80px);
    background: #fff;
    margin: 0 auto;
    padding: 30px;
    box-sizing: border-box;

    .storageProcessFrom {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .form-box {
        .form-row {
          width: 500px;

          text-align: center;

          .title {
            color: #64c3a4;
            font-size: 20px;
            font-weight: bold;
            margin: 5px 0px 10px 0px;
          }

          .addBtn {
            color: #64c3a4;
            font-size: 16px;
            font-weight: bold;
            margin: 10px 0px;
            cursor: pointer;
          }

          ::v-deep .el-form-item {
            width: 500px;
            display: flex;
            align-items: center;
            justify-content: space-around;

            .el-form-item__content {
              width: 225px;
            }

            .el-form-item__label {
              width: 200px;
              text-align: right;
            }
          }

          .ipt {
            width: 225px;
          }

          .wm-ipt {
            width: 100px;
          }

          .upload-img {
            ::v-deep .el-upload {
              background-color: #fbfdff;
              border: 1px dashed #c0ccda;
              border-radius: 6px;
              box-sizing: border-box;
              width: 100px;
              height: 100px;
              cursor: pointer;
              line-height: 98px;
              vertical-align: top;
              color: #8c939d;
            }
          }
        }
        .code-tips {
          color: #f56c6c;
          font-size: 12px;
        }
      }

      .wm-box {
        .wuma {
          ::v-deep .el-form-item__content {
            width: 100px !important;
          }
        }

        ::v-deep .el-form-item__content {
          display: flex !important;
        }
      }

      .dialog-footer {
        margin-top: 20px;
      }
    }
  }
}
</style>
